"use strict";

exports.__esModule = true;
var _DashboardURLFilter = require("./DashboardURLFilter");
Object.keys(_DashboardURLFilter).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _DashboardURLFilter[key]) return;
  exports[key] = _DashboardURLFilter[key];
});